import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styles from './SelectPriority.module.scss';
import classNames from 'classnames/bind';
import { FlagFillIcon } from '~/assets/icons';
import BaseSelect from '~/components/common/base-select/BaseSelect';
import { SelectOption, SelectOptions } from '~/utils/types/common';
import { useEffect, useState } from 'react';
import { TASK_ACTION_INFO, TASK_ACTION_ICON } from '~/utils/constants/task';

export type SelectPriorityProps = {
  name: string;
  options?: SelectOptions;
  value?: string;
  label?: string;
  onChange?: (...event: any[]) => void;
  error?: boolean;
  helperText?: string;
};

const cx = classNames.bind(styles);

const SelectTaskAction = (props: SelectPriorityProps) => {
  //#region Destructuring Props
  const { ...restProps } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation('admin/job');
  //#endregion Declare Hook

  //#region Declare State
  const options: SelectOptions =
    props.options ||
    TASK_ACTION_INFO.map((value) => {
      return {
        id: value,
        name: t(`addTask.${value}`),
      };
    });

  const label = props.label || t('addTask.label');
  const [value, setValue] = useState<string>('');

  //#endregion Declare State

  //#region Implement Hook
  useEffect(() => {
    if (props.value) setValue(props.value);
  }, [props.value]);
  //#endregion Implement Hook

  //#region Handle Function
  const getIconForOption = (item: SelectOption) => {
    const index = options.findIndex((opt) => opt.id === item.id);
    return TASK_ACTION_ICON[index] || FlagFillIcon;
  };

  const renderSelectOptionComponent = (item: SelectOption) => {
    const IconComponent = getIconForOption(item);
    return (
      <Box className={cx('priority', item.id)}>
        <IconComponent className='w-[17px] option-icon' />
        {item.name}
      </Box>
    );
  };

  const renderSelectedOptionComponent = (item: SelectOption) => {
    const IconComponent = getIconForOption(item);
    return (
      <Box className={cx('priority', item.id, 'priority-selected')}>
        <IconComponent className='w-[17px] option-icon' />
        {item.name}
      </Box>
    );
  };
  //#endregion Handle Function

  return (
    <>
      <BaseSelect
        {...restProps}
        onChange={(e) => {
          setValue(e.target.value);
          if (props.onChange) {
            props.onChange(e);
          }
        }}
        value={value}
        menuClassName={cx('select-priority-menu')}
        label={label}
        options={options}
        renderSelected={(item: SelectOption) => renderSelectedOptionComponent(item)}
        renderOptionItem={(item: SelectOption) => renderSelectOptionComponent(item)}
      />
    </>
  );
};

export default SelectTaskAction;
